import React, { useState } from "react";
import Seo from "../components/Seo";
import { PageHero, CTABand } from "../components/Shared";
import { FAQS } from "../data/faqs";
import { ChevronDown } from "lucide-react";

const BASE = "https://carefirstoh.com";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const Resources = () => {
  const [open, setOpen] = useState(0);
  return (
    <div>
      <Seo title="Resources & FAQ | Home Health Care Questions | CareFirst Columbus OH" description="Answers to common home health care questions: Medicare and Medicaid coverage, referrals, how to start services, service areas and more from CareFirst Columbus, Ohio." canonical={BASE + "/resources"} jsonLd={faqSchema} />
      <PageHero title="Resources & Frequently Asked Questions" subtitle="Helpful answers for patients, families, and referring professionals." crumbs={[{ label: "Home", to: "/" }, { label: "Resources" }]} />

      <section className="bg-white py-16">
        <div className="max-w-[860px] mx-auto px-4 space-y-4">
          {FAQS.map((f, i) => (
            <div key={i} className="border border-gray-200 rounded-xl overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-[#eef6ea] transition-colors">
                <span className="font-semibold text-[#16357a] text-[16px]">{f.q}</span>
                <ChevronDown size={20} className={`text-[#4ca82f] flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <div className="px-5 pb-5 text-[#555] text-[15px] leading-relaxed">{f.a}</div>}
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default Resources;
